import bindStorage from 'nuxt-vuex-localstorage/plugins/bindStorage'

export default (ctx) => {
  const options = {"localStorage":["userLoginsForPinLogin","customer","currentStore","cartItems","catalog"]}
  bindStorage(ctx, options)
}
